import React, { useState, useEffect } from "react";
import axios from "axios";
import io from "socket.io-client";

const socket = io("http://192.168.0.33:4000"); // Backend ka Socket.io server

export default function EmailSender() {
    const [file, setFile] = useState(null);
    const [subject, setSubject] = useState("");
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [totalEmails, setTotalEmails] = useState(0);
    const [sentEmails, setSentEmails] = useState([]);
    const [failedEmails, setFailedEmails] = useState([]);

    useEffect(() => {
        // Real-time progress updates
        socket.on("progress", ({ current, total }) => {
            setProgress(current);
            setTotalEmails(total);
        });

        // Receive final sent & failed emails
        socket.on("emailResult", ({ success, failed }) => {
            setSentEmails(success);
            setFailedEmails(failed);
            setLoading(false);
        });

        return () => {
            socket.off("progress");
            socket.off("emailResult");
        };
    }, []);

    const handleUpload = async () => {
        if (!file) {
            alert("Please select a CSV file.");
            return;
        }

        setLoading(true);
        setProgress(0);
        setTotalEmails(0);
        setSentEmails([]);
        setFailedEmails([]);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("subject", subject);

        try {
            await axios.post("http://192.168.18.104:5000/runemails", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Failed to upload file");
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Upload Data Here</h2>
            <p><i>Note: CSV must have maximum 2000 rows and column sequence like this <b>"email | clientName | businessName | emailName"</b> with exact spellings.</i></p>

            <div className="row">
                <div className="col-sm-6">
                    <input
                        className="form-control"
                        type="file"
                        accept=".csv"
                        onChange={(e) => setFile(e.target.files[0])}
                    />
                </div>
                <div className="col-sm-6">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Subject For The Emails"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </div>
            </div>
            <br />
            <button className="btn btn-primary" onClick={handleUpload} disabled={loading}>
                {loading ? "Processing..." : "Run All Emails"}
            </button>

            {/* Progress */}
            {totalEmails > 0 && (
                <h3>Progress: {progress}/{totalEmails}</h3>
            )}

            {/* Successfully Sent Emails */}
            {sentEmails.length > 0 && (
                <>
                    <h4>✅ Successfully Sent Emails</h4>
                    <ul>
                        {sentEmails.map((email, index) => <li key={index}>{email}</li>)}
                    </ul>
                </>
            )}

            {/* Failed Emails */}
            {failedEmails.length > 0 && (
                <>
                    <h4>❌ Failed Emails</h4>
                    <ul>
                        {failedEmails.map((email, index) => <li key={index}>{email}</li>)}
                    </ul>
                </>
            )}
        </div>
    );
}
